<template>
  <div class="section-box outline">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect v-model="searchParams.dateFrom" mode="date" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect v-model="searchParams.dateTo" mode="date" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="das-form-container">
      <div class="das-form-title-container">
        <div class="das-form-title">
          <span class="main-title"> Biểu đồ tròn </span>
        </div>
      </div>
      <div class="chart-container">
        <VChart
          class="chart"
          :option="chartOptions"
          autoresize
          :loading="false"
          @click="clickChart"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import { getPieChart } from '@/api/report_service/houseKeeperReport'

use([PieChart, TitleComponent, TooltipComponent, LegendComponent])

export default {
  components: {
    CalendarSelect,
    VChart
  },
  mounted() {
    this.attachData()
  },
  data() {
    return {
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      chartOptions: {
        title: {
          text: 'Biểu đồ tròn của từng nhóm dịch vụ',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: null
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          left: 0,
          top: 100
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '60%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },
    clickChart(event) {
      this.$emit('clickPie', event, this.searchParams)
    },
    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.attachData()
    },
    async attachData() {
      let data = await getPieChart(this.searchParams)
      let dataPie = []
      let totalRevenue = 0
      data.data.map(it => {
        dataPie.push({
          id: it.room_service_group_id,
          value: it.revenue,
          name: it.room_service_group_nm
        })
        totalRevenue += it.revenue
      })
      // console.log('checkkk pie', dataPie)
      this.chartOptions.series[0].data = [...dataPie]
      this.chartOptions.tooltip.formatter = params => {
        // console.log(params, 'check params')
        return `${params.name} : ${this.$displayCurrency(params.value)} VND (${(
          (parseFloat(params.value) / totalRevenue) *
          100
        ).toFixed(2)} %)`
      }
      // console.log('check chart', this.chartOptions.series[0].data)
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  display: flex;
  justify-content: center;

  .chart {
    width: 100%;
    height: 500px;
  }
}
</style>
